import React from 'react';
import { Container, Stack, useTheme } from '@mui/system';
import { Box, Typography } from '@mui/material';

const ghosts = [
  {
    question: `What are Ghost Challenges?`,
    answer: `Ghost Challenges allow players to play against each other "offline". Similar to correspondence matches in Chess or how Words With Friends works. You can challenge an offline player and when they sign on, they can complete the challenge.`,
  },
  {
    question: `How do I challenge someone?`,
    answer: `Click the ghost icon next to the persons name in the online list. Select your game settings, then play!
    `,
  },
  {
    question: `What else should I know about Ghosts?`,
    answer: `- Ghost Challenges expire after 7 days. So if your opponent does not respond within 7 days, your Ghost Challenge will convert into a solo game and will be accounted for in your Solo Punchcard.
    - You can play ranked Ghost Challenges. The player's MMRs at the time the Ghost Challenge is complete will be used to calculate their final MMR. MMRs shouldn't fluctuate much within 24 hours, so we feel this mechanism is ok.
    - Set your statuses to let others know if they should challenge you or not.
    - You completed Ghost Challenge will be displayed in the main lobby.
    - You get 3 challenges per day and can challenge the same person only once a day.
    - Both players will see the same letter revealing sequence.
    `,
  },
];

export const GhostChallenges = () => {
  return (
    <Container sx={{ paddingBottom: 10 }}>
      <Typography variant="h4" textAlign={'center'} mb={4}>
        Ghost Challenges
      </Typography>
      {ghosts.map((o) => (
        <>
          <Stack direction={'row'} spacing={1} mt={2}>
            <Typography color="success.main">Q:</Typography>
            <Typography variant="body1">{o.question}</Typography>
          </Stack>
          <Stack direction={'row'} spacing={1} mt={1} mb={1}>
            <Typography color="ranked.main">A:</Typography>
            <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
              {o.answer}
            </Typography>
          </Stack>
        </>
      ))}
    </Container>
  );
};
